import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DraggableDialog(props) {
  // const [ open, setOpen] = React.useState(false);
  const { open, title, body, cancel, confirm, onCancel, onConfirm } = props;

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
      <Dialog
        open={open}
        onClose={onCancel || null}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{body || "Tem certeza disso?"}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onCancel || null} color="primary">{cancel || "Cancelar"}</Button>
          <Button onClick={onConfirm || null} color="primary">{confirm || "Confirmar"}</Button>
        </DialogActions>
      </Dialog>
  );
}
